import React from 'react';
import {FormMessage} from "../../style";

export default () => {
  return(
    <FormMessage>
      <i className="icon mapsa-info form-message-icon"/>
      ​​با اتمام مدت زمان هر طرح، اطلاعات شما محفوظ بوده و فرصت کافی برای تمدید طرح خود را خواهید داشت.
    </FormMessage>
  );
};